import { ContactType } from 'src/app/features/tooling/models/tool-form-types';

/**
 * Mapping from ContactType enum to backend numeric ID
 */
export const CONTACT_TYPE_ID_MAP: Record<ContactType, number> = {
  [ContactType.ServiceNowBusinessOwner]: 1,
  [ContactType.ServiceNowTechnicalOwner]: 2,
  [ContactType.ServiceNowSupportGroup]: 3,
  [ContactType.SupportGroup]: 4,
  [ContactType.Owner]: 5,
  [ContactType.SupportLink]: 6,
};

/**
 * Direct mapping from backend numeric ID to display label.
 * Backend always returns numbers 1-6.
 */
export const CONTACT_TYPE_LABEL: Record<number, string> = {
  1: 'Business Owner',
  2: 'Technical Owner',
  3: 'Support Group',
  4: 'Support Group',
  5: 'Owner',
  6: 'Support Link',
};
